import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

import { ButtonSize } from '@design-system/components/molecules/button/entities/button.types';

@Component({
  selector: 'app-close-webview',
  templateUrl: './close-webview.component.html',
  styleUrls: ['./close-webview.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CloseWebviewComponent {

  @Input() active: boolean;
  @Output() closeWebview : EventEmitter<void> = new EventEmitter<void>();

  public readonly buttonSize = ButtonSize.SM;

  constructor() { }

  public onAccept(): void {
    this.closeWebview.emit();
  }

}
